/**
 * 可复用的富文本弹窗组件
 */
class RichTextPopup {
  constructor(options = {}) {
    this.options = {
      modalClass: "rich-text-popup__modal",
      triggerClass: "rich-text-popup__content",
      overlayClass: "rich-text-popup__overlay",
      closeBtnClass: "rich-text-popup__close-btn",
      ...options,
    };
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    // 绑定点击事件
    document.addEventListener("click", (e) => {
      const trigger = e.target.closest(`[data-popup-trigger]`);
      if (trigger) {
        e.preventDefault();
        const popupId = trigger.dataset.popupTrigger;
        this.openPopup(popupId);
      }

      // 关闭弹窗
      const closeBtn = e.target.closest(`[data-popup-close]`);
      if (closeBtn) {
        e.preventDefault();
        const popupId = closeBtn.dataset.popupClose;
        this.closePopup(popupId);
      }

      // 点击遮罩层关闭弹窗
      if (e.target.classList.contains(this.options.overlayClass)) {
        const popupId = e.target.dataset.popupClose;
        this.closePopup(popupId);
      }
    });

    // ESC键关闭弹窗
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        this.closeAllPopups();
      }
    });
  }

  openPopup(popupId) {
    const popup = document.getElementById(`popup-${popupId}`);
    if (popup) {
      popup.hidden = false;
      document.body.style.overflow = "hidden";

      requestAnimationFrame(() => {
        popup.classList.add("show");
      });
    }
  }

  closePopup(popupId) {
    const popup = document.getElementById(`popup-${popupId}`);
    if (popup) {
      popup.classList.remove("show");

      setTimeout(() => {
        popup.hidden = true;
        document.body.style.overflow = "";
      }, 300);
    }
  }

  closeAllPopups() {
    const popups = document.querySelectorAll(`.${this.options.modalClass}`);
    popups.forEach((popup) => {
      if (!popup.hidden) {
        const popupId = popup.dataset.popupId;
        this.closePopup(popupId);
      }
    });
  }
}

// 自动初始化
document.addEventListener("DOMContentLoaded", () => {
  new RichTextPopup();
});

// 导出供其他模块使用
window.RichTextPopup = RichTextPopup;
